<template>
  <ci-main-status
    v-if="hasActualPipeline"
    :size="2"
    :show-title="false"
    :only-icon="true"
    :status="actualPipeline.status"
    :icon-size="6"
  />
</template>

<script>
import CiMainStatus from '@shared/modules/ci-cd/components/ci-main-status';
import CiService from '../ci-cd.service';

export default {
  name: 'MergeRequestCiPipelineStatus',
  components: { CiMainStatus },
  data() {
    return {
      actualPipeline: null,
      hasActualPipeline: false
    };
  },
  mounted() {
    CiService.getMergeRequestActualPipeline(
      this.$route.params.alias,
      this.$route.params.projectAlias,
      this.$route.params.id
    ).then((res) => {
      this.hasActualPipeline = res.hasPipeline;
      this.actualPipeline = res?.pipelineModel;
    });
  }
};
</script>
